module.exports = __webpack_public_path__ + "img/hide.06782433.png";